/* src/app/pages/ui-kit/components/datepicker-range-view/datepicker-range-view.component.scss */
.box {
  display: flex;
  gap: 14px;
  align-items: center;
  margin-bottom: 30px;
}
.value-display {
  margin-top: 1rem;
  padding: 0.5rem;
  background: var(--ion-color-primary-tint);
  border-radius: 4px;
  color: var(--ion-color-primary-contrast);
  font-family: monospace;
  margin-bottom: 30px;
}
.error-display {
  margin-top: 0.5rem;
  color: var(--danger-regular-default);
  font-size: 0.9rem;
  margin-bottom: 30px;
}
/*# sourceMappingURL=datepicker-range-view.component.css.map */
